/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_FeedbackInputs */

const da_privacy_data_feedback = /** @type {(inputs: Privacy_Data_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Feedback om appen:** hvis du har accepteret statistik og bruger knappen »Feedback om appen«, gemmer vi dit svar sammen med dit navn og din e-mailadresse. Skriv ikke elevernes navne.`)
};

/** @type {(inputs: Privacy_Data_FeedbackInputs) => LocalizedString} */
const en_privacy_data_feedback = da_privacy_data_feedback;

/**

* @param {Privacy_Data_FeedbackInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_feedback = /** @type {((inputs?: Privacy_Data_FeedbackInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_FeedbackInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_feedback(inputs)
	return /** @type {LocalizedString} */ ("**Feedback om appen:** hvis du har accepteret statistik og bruger knappen »Feedback om appen«, gemmer vi dit svar sammen med dit navn og din e-mailadresse. Skriv ikke elevernes navne.")
});